export function truncate(text, maxLength = 24) {
    if (!text) return text;
    const str = String(text);
    return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;
}
